const slides = [
  {
    image: "https://www.hotnewhiphop.com/imgprst/765x510-cover-81-auto/2025/01/GettyImages-1874467080.jpg",
    title: "New Album Release",
    description: "Check out the latest tracks!",
    buttonText: "Listen Now",
    buttonLink: "#",
  },
  {
    image: "https://www.hotnewhiphop.com/imgprst/765x510-cover-81-auto/2023/11/GettyImages-1528446117.jpg",
    title: "Exclusive Tracks",
    description: "Only available here!",
    buttonText: "Explore",
    buttonLink: "#",
  },
  {
    image: "https://www.hotnewhiphop.com/imgprst/765x510-cover-81-auto/2024/12/Drake-11-1-scaled.jpg",
  },
];

export default slides;